import React from "react";
import { Body5MediumTypography } from "../../../primitives/Typography/typographyVariants";
import { colorPalette } from "../../../theme/colors";
import { Icon } from "../../../components/Icon/Icon";
import { FAQCardContainer } from "./FAQCard.styles";
import { FAQCardProps } from "./FAQCard.types";
import FlexRow from "../../../components/Layout/FlexRow/FlexRow";
import { getColor } from "../../../theme/theme";

export const FAQCard: React.FC<FAQCardProps> = ({
  question,
  leftIcon,
  rightIcon = "fa-solid fa-arrow-up-right",
  onClick,
  dataCy = "faq-card",
  leftIconColor,
  rightIconColor,
  disabled = false,
  backgroundColor = "background.default.default",
  showBorderBottom = false,
  borderBottomColor = "border.default.default",
}) => {
  const handleClick = () => {
    if (disabled || !onClick) return;
    onClick();
  };

  return (
    <FlexRow
      onClick={handleClick}
      backgroundColor={backgroundColor}
      data-cy={dataCy}
      cursor={disabled || !onClick ? "default" : "pointer"}
      opacity={disabled ? 0.5 : 1}
      py={16}
      px={20}
      alignItems="center"
      width="100%"
      gap={8}
      borderBottom={
        showBorderBottom
          ? `1px solid ${getColor("border.default.default")}`
          : "none"
      }
    >
      <FlexRow gap={8} alignItems="center" width="unset" flex={1}>
        {leftIcon && (
          <Icon
            name={leftIcon}
            size="12"
            height="16"
            width="16"
            color={leftIconColor}
            dataCy={`${dataCy}-left-icon`}
          />
        )}
        <Body5MediumTypography
          color="text.default.default"
          data-cy={`${dataCy}-question`}
          style={{ flex: 1 }}
        >
          {question}
        </Body5MediumTypography>
      </FlexRow>
      {rightIcon && (
        <Icon
          name={rightIcon}
          size="12"
          height="16"
          width="16"
          color={rightIconColor || colorPalette.popBlack[100]}
          dataCy={`${dataCy}-right-icon`}
        />
      )}
    </FlexRow>
  );
};
